import classNames from "classnames";
import React, { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useForm } from "react-hook-form";
import { Constants } from "../../../../constants/constants";
import { UpsellPanelSteps } from "../../../../constants/upsellPanelEnumsAndConstants";
import useRecaptcha from "../../../../hooks/useRecaptcha";
import { useUpsellWidgetRedirect } from "../../hooks/useRedirectContext";
import { useUpsellWidgetContainer } from '../../hooks/useUpsellWidgetContainerContext';
import { useUpsellWidgetModel } from '../../hooks/useUpsellWidgetModelContext';
import { useLoginMutation } from "../../services/hooks/useLoginMutation";
import ValidationErrorsSummary from "../UpSellWidgetContainer/ValidationErrorsSummary";
import { EmailInput, PasswordInput, RememberMeCheckbox } from "./FormControls";
import OAuthArticlesLoginPanel from "../OAuthArticlesLoginPanel";
import AccountLockedSummary from "../UpSellWidgetContainer/AccountLockedSummary";

const SignupAndLoginTab = ({ model, goToStep, boldClass }) => {
  if (model.isPromo || model.hideLogin) return null;

  const signUpClass = `cursor-pointer text-color-gray-16 full-width d-block py-2 border-bottom-4-gray-21-with-hover font-19 hover-color-brand-green ${boldClass}`;
  const loginClass = classNames(
    'text-color-deep-blue-2 full-width d-block py-2 font-19',
    model.isCompetitionPage ? "border-bottom-4-deep-blue-2" : "border-bottom-4-gray-51",
    boldClass
  );

  return (
    <div className="row mb-3">
      <div className="col-6 pr-0">
        <a className={signUpClass}
          onClick={() => goToStep(UpsellPanelSteps.Step1SignUp)}
        >
          Sign up
        </a>
      </div>
      <div className="col-6 pl-0">
        <div className={loginClass} >
          Log in
        </div>
      </div>
    </div>
  );
}

export const Step3Login = () => {
  const model = useUpsellWidgetModel();
  const { boldClass, goToStep, baseProps, updateBaseProps, handleErrorResponse, onSubmitError, setIsUpsellContainerLoading } = useUpsellWidgetContainer();
  const { handleRedirect } = useUpsellWidgetRedirect();
  const { captchaToken, executeCaptcha, recaptchaRef, handleRecaptcha } = useRecaptcha();
  const { mutate: loginUserMutation } = useLoginMutation();
  const [formErrors, setFormErrors] = useState({});
  const [isAccountLocked, setIsAccountLocked] = useState(false);
  const [isPmaUser, setIsPmaUser] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitted }
  } = useForm();

  const handleLoginSuccess = (response) => {
    if (response.status === Constants.RequestStatus.SUCCESS) {
      recaptchaRef.current?.reset();
      if (response.nextStep === UpsellPanelSteps.Step17MFALogin) {
        updateBaseProps({
          mfaModel: {
            maskedMobile: response.mobile,
            mfaAuthenticator: response.mfaAuthenticator,
            mfaText: response.mfaText,
            RememberMe: false,
            formLoading: false,
          }
        });
        setIsUpsellContainerLoading(false);
        goToStep(response.nextStep);
        return;
      }
      window.authenticateAllDomains(response);
      if (model.investmentQuizGoalTypeID > 0) {
        //model.createSOA();
        return;
      } else if (model.investmentQuizSoaID > 0) {
        //model.updateSOASubscriber();
      } else {
        handleRedirect(response);
      }
    } else if (response.errors) {
      handleErrorResponse(response.errors, setFormErrors);
    } else if (response.isAccountLocked) {
      setIsAccountLocked(response.isAccountLocked);
      setIsPmaUser(response.isPMAUser)
    }
    setIsUpsellContainerLoading(false);
  }

  const onSubmit = async (formData) => {
    setIsUpsellContainerLoading(true);
    updateBaseProps({
      user: {
        ...baseProps.user,
        email: formData.email
      }
    })
    let token = captchaToken || await executeCaptcha();

    loginUserMutation(
      { ...formData, captchaResponse: token },
      {
        onSuccess: handleLoginSuccess,
        onError: (error) => onSubmitError(error)
      });
  };
  return (
    <div className="step3">
      {isSubmitted && errors && (<div className="upsell-container-content">
        <ValidationErrorsSummary validationErrors={{ ...errors, ...formErrors }} renderAsHtml={true} />
      </div>)}
      <SignupAndLoginTab model={model} goToStep={goToStep} boldClass={boldClass} />

      <form className="join-form-inline form-is-custom form-disable-pristine-error" onSubmit={handleSubmit(onSubmit)} noValidate >
        <div className="row">
          {isAccountLocked ? (
            <>
            <AccountLockedSummary isAccountLocked={isAccountLocked} isPmaUser={isPmaUser} />
            </>
          ) : (
            <>
              <div className="col-md-12">
                <EmailInput register={register} errors={errors} />
              </div>
              <div className="col-md-12">
                <PasswordInput register={register} errors={errors} placeholderText="Enter password" />
              </div>
              <div className="col-md-12 text-left">
                <RememberMeCheckbox register={register} />
              </div>
            </>
          )}
          <div className="col-md-12 col-12">
            <ReCAPTCHA
              size="invisible"
              ref={recaptchaRef}
              sitekey={window.reCaptchaKey}
              onChange={handleRecaptcha}
            />
            <button id="loginBtn" className={`btn btn-primary btn-fw btn-brand-style-with-pad-sm ${boldClass} font-19-no-line-height`} type="submit" disabled={isAccountLocked}>
              Login
            </button>
          </div>
          {!model.hideSignup && (
            <div className="col-md-12 col-12">
              <p className="mb-3">
                Not a member?{" "}
                <a href="#" className={`${model.isCompetitionPage ? "text-primary text-underline" : "link-primary"}`}
                  onClick={(e) => {
                    e.preventDefault();
                    goToStep(UpsellPanelSteps.Step1SignUp);
                  }}
                >
                  Sign up
                </a>
              </p>
            </div>
          )}
          <div className="col-md-12 col-12">
            <p className="forgot-pwd">
              Forgotten password?{" "}
              <a href="#" className={`${model.isCompetitionPage ? "text-primary text-underline" : "link-primary"}`}
                onClick={(e) => {
                  e.preventDefault();
                  goToStep(UpsellPanelSteps.Step16ForgotPassword);
                }}
              >
                Click here
              </a>
            </p>
          </div>
        </div>
      </form>      
      <OAuthArticlesLoginPanel />
    </div>
  );
};

